// extracted by mini-css-extract-plugin
export default {"cashbackRightBarListHeader":"style_cashbackRightBarListHeader__3IWyp","empty":"style_empty__NLaFB","label":"style_label__gSnIx","total":"style_total__WuBVe"};